<template>
     <div class="text-center">
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="500"
            bottom left
            origin="top right"
            transition="scale-transition"
            offset-y>

            <template v-slot:activator="{ on }">
                <v-btn min-width="0" text v-on="on" style="margin-right: 80px;">
                    <v-icon color="primary">
                    mdi-bed-outline
                    </v-icon>
                </v-btn>
            </template>
            <v-card>
                <v-card-title class="headline">
                    <p class="pl-7 mb-0 mt-8">
                        Edit Goodies
                    </p>
                </v-card-title>

                 <!-- >>> Row - New Hotel Goodies -->
                <v-form ref="form_Goodies" lazy-validation>
                    <!-- >>> Form, Fields -->
                    <v-list>
                        <v-list-item>
                            <v-col>
                            <v-row>
                                <v-col cols="12" sm="8">
                                    <v-text-field
                                        v-model="input_GoodyDescription"
                                        :rules="[
                                            rules.req(input_GoodyDescription),
                                            rules.max(50, input_GoodyDescription),
                                            rules.min(2, input_GoodyDescription)
                                        ]"
                                        name="input_AddHotelGoody"
                                        maxlength="50"
                                        counter
                                        clearable>
                                        <template v-slot:label>
                                            Goody <span style="color: red; font-size: 1.4rem;">*</span>
                                        </template>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="12" sm="4">
                                    <v-btn
                                        block
                                        class="mt-4"
                                        color="primary"
                                        @click="onValidate_HotelGoodies">
                                        Add
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col cols="12" sm="12">
                                    <v-data-table
                                        :headers="headers"
                                        :items="get_HotelGoodies"
                                        :disable-pagination="true"
                                        :hide-default-footer="true"
                                        sort-by="description"
                                        :sort-desc="true"
                                        :fixed-header="true"
                                        height="300"
                                        class="elevation-1 mt-6 data-table-custom-colors">

                                        <template v-slot:item.description="{ item }">
                                            <p style="font-weight:300; margin: 0;">{{ item.description }}</p>
                                        </template>

                                        <!-- >>> Action:Column -->
                                        <!-- <template v-slot:item.actions="{ item }">
                                            <v-icon small @click="onClick_DeleteHotelGoodiesEntry(item)">
                                                mdi-delete
                                            </v-icon>
                                        </template> -->
                                        <!-- <<< Action:Column -->
                                    </v-data-table>
                                </v-col>
                            </v-row>
                            <!-- <<< Row - List of Hotel Goodies -->
                            </v-col>

                        </v-list-item>
                    </v-list>
                </v-form>
                <!-- <<< Row - New Hotel Goodies -->
            </v-card>

        </v-menu>
    </div>



</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import { eventBus } from '../../../../main';


    export default {
        name: 'HotelGoodiesMenue',

        /* >>> *************************************************************** / /* Data */
        data: function() {
            return {
                menu: false,
                // >>> ------------------------------------ 'Form Validation Rules'
                valid : true,
                rules: {
                    req(v) {
                        return (v || '').toString().length > 0 || `Field is required`;
                    },

                    min(min, v) {
                        return (v === null || v === '' || v === undefined) || v.length >= min || `Length must be at least ${min}`;
                    },

                    max(max, v) {
                        return (v || '').length <= max || `Length may not be greater than ${max}.`;
                    },
                },
                input_GoodyDescription: '',

                headers : [
                    { text: 'Description', value: 'description', class: 'sticky-header grey lighten-3' },
                    // { text: 'Actions', value: 'actions', class: 'sticky-header grey lighten-3' }
				],
            };
        }, // eo funtion data()
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_HotelGoodies'
            ])
        }, // eo computed{}
		/* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Watch */
        watch: {
            menu (val) {
                if(val === false) {
                    this.onEmit_ResetGoodyInput();
                }
            }
        },
        /* <<< ****************************************************************/


        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;

            me.$toc('>>> views/hotels/components/core/GoodiesMenue.vue >>> created');
            eventBus.$on('goodywascreated', this.onEmit_ResetGoodyInput);

		}, // eo function created()


        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_AddHotelGoodies'
            ]),


            /*******************************************************************
            * onEmit_ResetGoodyInput()
            *
            * Desc: Clear Goody Input and reset validation.
            * Note:
            *
            */
            onEmit_ResetGoodyInput: function() {

                // >>> ------------------ reset validation
                if(this.$refs.form_Goodies !== undefined) {
                    this.$refs.form_Goodies.resetValidation();
                }

                this.input_GoodyDescription = '';

            }, // eo function onEmit_ResetGoodyInput()


            /******************************************************************* 'Forms Validations'
            * Forms Validations:
            *******************************************************************/
            /*******************************************************************
            * onValidate_HotelGoodies()
            *
            * Desc: Check if hotel goodies Form is valid.
            * Note:
            *
            */
            onValidate_HotelGoodies: function() {

                const me = this;
                let payload = null;


                me.$toc('>>> views/hotels/components/core/GoodiesMenu.vue >>> onValidate_HotelGoodies');
                if(this.$refs.form_Goodies.validate() === true){
                    payload = {
                        code: null,
                        description: this.input_GoodyDescription,
                        id: null
                    }

                    this.actn_call_AddHotelGoodies(payload)
                }

            }, // eo function onValidate_HotelGoodies()

        },
        /* <<< ****************************************************************/

    }

</script>

<style>
    .v-btn__content {
        font-size: 12px;
    }
    .v-card {
        margin-top: 0px;
        margin-bottom: 0px;
    }
</style>